<template>
  <div>
    <div class="step-billing-overview-notification">{{ lang.SET401 }}</div>
    <div class="step-billing-overview-title">{{ lang.SET400 }}</div>

    <div class="row">
      <div class="col-md-6 billing-address-block">
        <b>{{ lang.SET402 }}</b>
        <br />
        {{ shopperBillingAddress.Name }}
        <br />
        {{ shopperBillingAddress.Street }}
        <br />
        {{ shopperBillingAddress.PLZCity }}
      </div>
      <div class="col-md-6 bank-details-block">
        <b>{{ lang.SET403 }}</b>
        <br />
        {{ lang.SET407 }}:
        {{ bankDetailsData.BankName }}
        <br />
        {{ lang.SET409 }}:
        {{ bankDetailsData.SwiftCode }}
        <br />
        {{ lang.SET408 }}:
        {{ bankDetailsData.AccountNumber }}
        <br />
        {{ lang.SET410 }}:
        {{ bankDetailsData.AccountName }}
      </div>
      <div class="col-md-12">
        <table class="table">
          <thead>
            <tr>
              <th class="text-center" style="width: 15%">{{ lang.SET404 }}</th>
              <th class="text-center" style="width: 40%">{{ lang.SET405 }}</th>
              <th class="text-center" style="width: 15%">{{ lang.SET406 }}</th>
              <th
                class="text-center"
                style="width: 15%"
                v-if="!vatNotMandatory"
              >
                {{ lang.SET412 }} ({{
                  shopperCart.CartItems[0].VatRate * 100
                }}%)
              </th>
              <th class="text-center" style="width: 15%">{{ lang.SET413 }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="cartItem in shopperCart.CartItems"
              :key="cartItem.CartItemGuid"
            >
              <td style="width: 15%">{{ cartItem.SurveyInstanceId }}</td>
              <td style="width: 40%">{{ cartItem.SurveyTitle }}</td>
              <td style="width: 15%">
                {{ globals.getCurrencyString(cartItem.Total, "EUR") }}
              </td>
              <td style="width: 15%" v-if="!vatNotMandatory">
                {{ globals.getCurrencyString(cartItem.VatValue, "EUR") }}
              </td>
              <td style="width: 15%">
                {{ globals.getCurrencyString(cartItem.PurchaseMoney, "EUR") }}
              </td>
            </tr>
            <tr class="total-background">
              <td colspan="2" class="align-total-text format-total-text">
                {{ lang.SET411 }}
              </td>
              <td class="format-total-text">
                {{ globals.getCurrencyString(shopperCart.Total, "EUR") }}
              </td>
              <td class="format-total-text" v-if="!vatNotMandatory">
                {{
                  globals.getCurrencyString(shopperCart.TotalVatValue, "EUR")
                }}
              </td>
              <td class="format-total-text">
                {{
                  globals.getCurrencyString(
                    shopperCart.TotalPurchaseMoney,
                    "EUR"
                  )
                }}
              </td>
            </tr>
            <tr class="payout-background">
              <td colspan="2" class="align-total-text format-total-text">
                {{ lang.SET414 }}
              </td>
              <td :colspan="vatNotMandatory ? 2 : 3" class="format-total-text">
                {{
                  globals.getCurrencyString(
                    shopperCart.TotalWithVatAndPurchaseMoney,
                    "EUR"
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillingOverview",
  props: {
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      lang: {
        SET400: "Billing Overview",
        SET401: "The submission of the invoice is binding!",
        SET402: "Billing address",
        SET403: "Bank details",
        SET404: "Check ID",
        SET405: "Project",
        SET406: "Payment",
        SET407: "Bank Name",
        SET408: "IBAN",
        SET409: "BIC",
        SET410: "Account Owner",
        SET411: "Total",
        SET412: "VAT",
        SET413: "Others",
        SET414: "Payout",
      },
    };
  },
  computed: {
    bankDetailsData() {
      return this.data.BankDetails;
    },
    shopperCart() {
      return this.data.ShopperCart;
    },
    shopperBillingAddress() {
      let data = this.data.ShopperProfileData;
      return {
        Name: `${data.FirstName} ${data.LastName}`,
        Street: `${data.Address1}`,
        PLZCity: `${data.PostalCode} ${data.City}`,
      };
    },
    vatNotMandatory() {
      return !!this.data.ShopperProfileData.VatNotMandatory;
    },
  },
  mounted() {
    this.globals.getLanguageStrings(this);
  },
};
</script>

<style scoped>
.step-billing-overview-title {
  background: lightgray;
  margin-bottom: 5px;
  font-weight: bold;
  padding: 5px;
}
.step-billing-overview-notification {
  margin-bottom: 10px;
  font-weight: bold;
  color: red;
}
.align-total-text {
  text-align: right;
}
.format-total-text {
  font-weight: bold;
}
.total-background {
  background-color: #eeeeee !important;
}
.payout-background {
  background-color: #d8d8d8 !important;
}
.bank-details-block {
  margin-bottom: 5px;
  text-align: left;
}
.billing-address-block {
  margin-bottom: 5px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// BillingOverview.vue?7d3ffabc